module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/writable-browser.js
// module id = 302
// module chunks = 8